<template>
    <div>
        <b-row class="mb-3">
            <b-col md="6">
                <b-row>
                    <b-col md="6">
                        <p class="head-text">DSO List</p>
                    </b-col>
                    <b-col md="3">
                        <eb-select
                            style="background-color: #fff"
                            id="reportData1DateFilter"
                            type="text"
                            label="text"
                            v-model="selectedDate"
                            :selected="selectedDate.text"
                            @input="changeDate"
                            :options="dayRadioOption"
                        ></eb-select>
                        <c-date
                            ref="compRefs"
                            modalRef="modalRef"
                            modalId="dateModal"
                            @customDateRange="findDateResult"
                        ></c-date>
                    </b-col>
                    <b-col md="3"
                        ><eb-select
                            type="select"
                            v-model="selectedCustomersName"
                            :options="customerList"
                            label="text"
                            :id="'selectCustomer'"
                            @input="changeCustomer"
                            :selected="selectedCustomersName"
                        ></eb-select>
                    </b-col>
                </b-row>
                <b-card>
                    <div
                        v-if="
                            chartData &&
                            chartData.labels &&
                            chartData.labels.length
                        "
                    >
                        <BarChart
                            :chart-data="chartData"
                            :chart-options="barChartOptions"
                        />
                    </div>
                </b-card>
            </b-col>
            <b-col md="6">
                <b-row>
                    <b-col md="12">
                        <p class="head-text">Customer DSO List</p>
                        <eb-select
                            style="background-color: #fff"
                            id="reportData2DateFilter"
                            type="text"
                            label="text"
                            v-model="selectedDate2"
                            :selected="selectedDate2.text"
                            @input="changeDate2"
                            :options="dayRadioOption"
                        ></eb-select>
                        <c-date
                            ref="compRefs2"
                            modalRef="modalRef2"
                            modalId="dateModal2"
                            @customDateRange="findDateResult2"
                        ></c-date>
                    </b-col>
                </b-row>

                <b-card>
                    <div
                        v-if="
                            pieData && pieData.labels && pieData.labels.length
                        "
                    >
                        <PieChart
                            :chart-data="pieData"
                            :chart-options="pieChartOptions"
                        />
                    </div>
                </b-card>
            </b-col>
            <b-col md="6">
                <b-row>
                    <b-col md="6">
                        <p class="head-text">USD value of ticket</p>
                    </b-col>
                    <b-col md="3">
                        <eb-select
                            style="background-color: #fff"
                            id="reportData3DateFilter"
                            type="text"
                            label="text"
                            v-model="selectedDate3"
                            :selected="selectedDate3.text"
                            @input="changeDate3"
                            :options="dayRadioOption"
                        ></eb-select>
                        <c-date
                            ref="compRefs3"
                            modalRef="modalRef3"
                            modalId="dateModal3"
                            @customDateRange="findDateResult3"
                        ></c-date>
                    </b-col>
                    <b-col md="3">
                        <eb-select
                            type="select"
                            v-model="selectedCustomersName2"
                            :options="customerList2"
                            label="text"
                            :id="'selectCustomer'"
                            @input="changeCustomer2"
                            :selected="selectedCustomersName2"
                        ></eb-select>
                    </b-col>
                </b-row>

                <b-card>
                    <div
                        v-if="
                            chartData1 &&
                            chartData1.labels &&
                            chartData1.labels.length
                        "
                    >
                        <BarChart
                            :chart-data="chartData1"
                            :chart-options="barChartOptions1"
                        />
                    </div>
                </b-card>
            </b-col>
            <b-col md="6">
                <b-row>
                    <b-col md="12">
                        <p class="head-text">Customer USD value of ticket</p>
                        <eb-select
                            style="background-color: #fff"
                            id="reportData4DateFilter"
                            type="text"
                            label="text"
                            v-model="selectedDate4"
                            :selected="selectedDate4.text"
                            @input="changeDate4"
                            :options="dayRadioOption"
                        ></eb-select>
                        <c-date
                            ref="compRefs4"
                            modalRef="modalRef4"
                            modalId="dateModal4"
                            @customDateRange="findDateResult4"
                        ></c-date>
                    </b-col>
                </b-row>
                <b-card>
                    <div
                        v-if="
                            pieData1 &&
                            pieData1.labels &&
                            pieData1.labels.length
                        "
                    >
                        <PieChart
                            :chart-data="pieData1"
                            :chart-options="pieChartOptions1"
                        />
                    </div>
                </b-card>
            </b-col>
            <b-col md="6">
                <b-row>
                    <b-col md="6">
                        <p class="head-text">Non productive hours by tech</p>
                    </b-col>
                    <b-col md="3">
                        <eb-select
                            style="background-color: #fff"
                            id="reportData6DateFilter"
                            type="text"
                            label="text"
                            v-model="selectedDate6"
                            :selected="selectedDate6.text"
                            @input="changeDate6"
                            :options="dayRadioOption"
                        ></eb-select>
                        <c-date
                            ref="compRefs6"
                            modalRef="modalRef6"
                            modalId="dateModal6"
                            @customDateRange="findDateResult6"
                        ></c-date>
                    </b-col>
                    <b-col md="3">
                        <eb-select
                            type="select"
                            v-model="selectedCustomersName3"
                            :options="customerList3"
                            label="text"
                            :id="'selectCustomer'"
                            @input="changeCustomer3"
                            :selected="selectedCustomersName3"
                        ></eb-select>
                    </b-col>
                </b-row>
                <b-card>
                    <div
                        v-if="
                            chartData3 &&
                            chartData3.labels &&
                            chartData3.labels.length
                        "
                    >
                        <BarChart
                            :chart-data="chartData3"
                            :chart-options="barChartOptions3"
                        />
                    </div>
                </b-card>
            </b-col>
            <b-col md="6">
                <b-col md="12">
                    <p class="head-text">
                        Customer Non productive hours by tech
                    </p>
                    <eb-select
                        style="background-color: #fff"
                        id="reportData5DateFilter"
                        type="text"
                        label="text"
                        v-model="selectedDate5"
                        :selected="selectedDate5.text"
                        @input="changeDate5"
                        :options="dayRadioOption"
                    ></eb-select>
                    <c-date
                        ref="compRefs5"
                        modalRef="modalRef5"
                        modalId="dateModal5"
                        @customDateRange="findDateResult5"
                    ></c-date>
                </b-col>
                <b-card>
                    <div
                        v-if="
                            chartData2 &&
                            chartData2.labels &&
                            chartData2.labels.length
                        "
                    >
                        <BarChart
                            :chart-data="chartData2"
                            :chart-options="barChartOptions2"
                        />
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import BarChart from "@/components/chart/newBarChart.vue";
import moment from "moment";
import cDate from "@/components/FormElements/CustomDate.vue";
import ebSelect from "@/components/FormElements/Select.vue";
import PieChart from "@/components/chart/newPieChart.vue";

export default {
    name: "reportData1",
    components: {
        BarChart,
        cDate,
        ebSelect,
        PieChart,
    },
    data: function () {
        return {
            isLoading: false,
            selectedCustomersName: "All",
            selectedCustomersName2: "All",
            selectedCustomersName3: "All",
            selectedCustomer: "ABC Enterprises",
            selectedDate: {
                text: "Today",
                value: 0,
            },
            selectedDate2: {
                text: "Today",
                value: 0,
            },
            selectedDate3: {
                text: "Today",
                value: 0,
            },
            selectedDate4: {
                text: "Today",
                value: 0,
            },
            selectedDate5: {
                text: "Today",
                value: 0,
            },
            selectedDate6: {
                text: "Today",
                value: 0,
            },
            startDate: "",
            endDate: "",
            startDate2: "",
            endDate2: "",
            startDate3: "",
            endDate3: "",
            startDate4: "",
            endDate4: "",
            startDate5: "",
            endDate5: "",
            startDate6: "",
            endDate6: "",
            dayRadioOption: [
                {
                    text: "Today",
                    value: 0,
                },
                {
                    text: "7 days",
                    value: 6,
                },
                {
                    text: "30 days",
                    value: 29,
                },
                {
                    text: "Custom",
                    value: "custom",
                },
            ],
        };
    },
    computed: {
        customerList() {
            let data = this.$store.getters["partner/GetCustomerDSOList"];
            const customerDataList = data["customer-no-of-dso-list"]
                ? data["customer-no-of-dso-list"].map((d) => {
                      return {
                          text: d.Customer_Name,
                          value: d.Customer_Name,
                      };
                  })
                : [];
            customerDataList.unshift({ text: "All", value: "all" });
            return customerDataList;
        },
        customerList2() {
            let data = this.$store.getters["partner/getUsdValueOfTickets"];
            const customerDataList = data["usd-value-of-tickets"]
                ? data["usd-value-of-tickets"].map((d) => {
                      return {
                          text: d.Customer_Name,
                          value: d.Customer_Name,
                      };
                  })
                : [];
            customerDataList.unshift({ text: "All", value: "all" });
            return customerDataList;
        },
        customerList3() {
            let data = this.$store.getters["partner/getNoOfNonProdHoursByTech"];
            const customerDataList = data["no-of-non-productive-hours-by-tech"]
                ? data["no-of-non-productive-hours-by-tech"].map((d) => {
                      return {
                        // should be customerName
                          text: d.Tech_Name,
                          value: d.Tech_Name,
                      };
                  })
                : [];
            customerDataList.unshift({ text: "All", value: "all" });
            return customerDataList;
        },
        chartData() {
            const dataList = this.$store.getters["partner/GetCustomerDSOList"];
            const labels = [];
            const dataSets = [
                {
                    label: "Invoices",
                    backgroundColor: "rgba(75, 192, 192, 0.6)",
                    data: [],
                },
                {
                    label: "Total Amount",
                    backgroundColor: "rgba(255, 99, 132, 0.6)",
                    data: [],
                },
            ];

            if (dataList && dataList["customer-no-of-dso-list"]) {
                if (dataList["customer-no-of-dso-list"].length > 0) {
                    dataList["customer-no-of-dso-list"].map((el) => {
                        labels.push(el.Customer_Name);
                        dataSets[0].data.push(parseInt(el.num_of_invoices));
                        dataSets[1].data.push(parseInt(el.total_amount));
                    });
                }
            }
            return {
                labels,
                datasets: dataSets,
            };
        },
        chartData1() {
            const dataList =
                this.$store.getters["partner/getUsdValueOfTickets"];
            const labels = [];
            const dataSets = [
                {
                    label: "Open Invoices",
                    backgroundColor: "rgba(75, 192, 192, 0.6)",
                    data: [],
                },
                {
                    label: "Close Invoices",
                    backgroundColor: "rgba(255, 99, 132, 0.6)",
                    data: [],
                },
            ];

            if (dataList && dataList["usd-value-of-tickets"]) {
                if (dataList["usd-value-of-tickets"].length > 0) {
                    dataList["usd-value-of-tickets"].map((el) => {
                        labels.push(el.Customer_Name);
                        dataSets[0].data.push(parseInt(el.open_invoices));
                        dataSets[1].data.push(parseInt(el.closed_invoices));
                    });
                }
            }
            return {
                labels,
                datasets: dataSets,
            };
        },
        barChartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        stacked: false,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                    y: {
                        stacked: false,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                        ticks: {
                            callback: function (value) {
                                const valueLegend =
                                    this.getLabelForValue(value);
                                const valueLegendRep = valueLegend.replaceAll(
                                    ",",
                                    ""
                                );
                                if (Number(valueLegendRep) < 2) {
                                    return valueLegendRep * 10;
                                } else {
                                    const valueShort =
                                        Number(valueLegendRep) / 1000;
                                    return valueShort + " " + "k";
                                }
                            },
                        },
                    },
                },
                plugins: {
                    tooltip: {
                        callbacks: {
                            label: (tooltipItem) => {
                                let data =
                                    this.$store.getters[
                                        "partner/GetCustomerDSOList"
                                    ];
                                if (data && data["customer-no-of-dso-list"]) {
                                    const item = data[
                                        "customer-no-of-dso-list"
                                    ].find(
                                        (el) =>
                                            el.Customer_Name ===
                                            tooltipItem.label
                                    );
                                    if (item) {
                                        return `${item.Type}: ${tooltipItem.raw}`;
                                    }
                                }
                                return tooltipItem.raw;
                            },
                        },
                    },
                },
            };
        },
        barChartOptions1() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        stacked: false,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                    y: {
                        stacked: false,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                        ticks: {
                            callback: function (value) {
                                const valueLegend =
                                    this.getLabelForValue(value);
                                const valueLegendRep = valueLegend.replaceAll(
                                    ",",
                                    ""
                                );
                                if (Number(valueLegendRep) < 2) {
                                    return valueLegendRep * 10;
                                } else {
                                    const valueShort =
                                        Number(valueLegendRep) / 1000;
                                    return valueShort + " " + "k";
                                }
                            },
                        },
                    },
                },
                plugins: {
                    tooltip: {
                        callbacks: {
                            label: (tooltipItem) => {
                                let data =
                                    this.$store.getters[
                                        "partner/getUsdValueOfTickets"
                                    ];
                                if (data && data["usd-value-of-tickets"]) {
                                    const item = data[
                                        "usd-value-of-tickets"
                                    ].find(
                                        (el) =>
                                            el.Customer_Name ===
                                            tooltipItem.label
                                    );
                                    if (item) {
                                        return `Total Amount: ${item.total_amount}(${tooltipItem.raw})`;
                                    }
                                }
                                return tooltipItem.raw;
                            },
                        },
                    },
                },
            };
        },
        pieData() {
            const data = this.$store.getters["partner/GetNumberOfDSO"];
            const labels = [];
            const dataSets = [
                {
                    data: [],
                    backgroundColor: [
                        "#42A5F5", // Blue
                        "#FF6384", // Red
                        "#36A2EB", // Light Blue
                        "#FFCD56", // Yellow
                        "#4CAF50", // Green
                        "#FF9800", // Orange
                        "#9C27B0", // Purple
                        "#E91E63", // Pink
                        "#2196F3", // Light Blue
                        "#FFC107", // Amber
                    ],
                    hoverBackgroundColor: [
                        "#64B5F6", // Hover Blue
                        "#FF8A80", // Hover Red
                        "#42A5F5", // Hover Light Blue
                        "#FFD54F", // Hover Yellow
                        "#81C784", // Hover Green
                        "#FFB74D", // Hover Orange
                        "#BA68C8", // Hover Purple
                        "#F06292", // Hover Pink
                        "#64B5F6", // Hover Light Blue
                        "#FFEB3B", // Hover Amber
                    ],
                },
            ];
            if (data && data["no-of-dso"]) {
                if (data["no-of-dso"].length > 0) {
                    data["no-of-dso"].map((el) => {
                        labels.push(el.Tech_Name);
                        dataSets[0].data.push(parseInt(el.total_sales));
                    });
                }
            }
            return {
                labels,
                datasets: dataSets,
            };
        },
        pieChartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        position: "top",
                    },
                    tooltip: {
                        callbacks: {
                            label: (tooltipItem) => {
                                const data =
                                    this.$store.getters[
                                        "partner/GetNumberOfDSO"
                                    ];
                                if (data && data["no-of-dso"]) {
                                    const item = data["no-of-dso"].find(
                                        (el) =>
                                            el.Tech_Name === tooltipItem.label
                                    );
                                    if (item) {
                                        return `Name: ${item.Tech_Name} Amount: ${tooltipItem.raw} Tech :${item.total_tech}`;
                                    }
                                }
                                return tooltipItem.raw;
                            },
                        },
                    },
                },
            };
        },
        pieData1() {
            const data =
                this.$store.getters["partner/getCustomerUsdValueOfTickets"];
            const labels = [];
            const dataSets = [
                {
                    data: [],
                    backgroundColor: [
                        "#42A5F5", // Blue
                        "#FF6384", // Red
                        "#36A2EB", // Light Blue
                        "#FFCD56", // Yellow
                        "#4CAF50", // Green
                        "#FF9800", // Orange
                        "#9C27B0", // Purple
                        "#E91E63", // Pink
                        "#2196F3", // Light Blue
                        "#FFC107", // Amber
                    ],
                    hoverBackgroundColor: [
                        "#64B5F6", // Hover Blue
                        "#FF8A80", // Hover Red
                        "#42A5F5", // Hover Light Blue
                        "#FFD54F", // Hover Yellow
                        "#81C784", // Hover Green
                        "#FFB74D", // Hover Orange
                        "#BA68C8", // Hover Purple
                        "#F06292", // Hover Pink
                        "#64B5F6", // Hover Light Blue
                        "#FFEB3B", // Hover Amber
                    ],
                },
            ];
            if (data && data["customer-usd-value-of-tickets"]) {
                if (data["customer-usd-value-of-tickets"].length > 0) {
                    data["customer-usd-value-of-tickets"].map((el) => {
                        labels.push(
                            `${this.selectedCustomer}: (Open Invoices)`
                        );
                        labels.push(
                            `${this.selectedCustomer}: (Closed Invoices)`
                        );
                        dataSets[0].data.push(parseInt(el.open_invoices));
                        dataSets[0].data.push(parseInt(el.closed_invoices));
                    });
                }
            }
            return {
                labels,
                datasets: dataSets,
            };
        },
        pieChartOptions1() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        position: "top",
                    },
                    tooltip: {
                        callbacks: {
                            label: (tooltipItem) => {
                                return tooltipItem.raw;
                            },
                        },
                    },
                },
            };
        },
        chartData2() {
            const dataList =
                this.$store.getters[
                    "partner/getCustomerNoOfNonProdHoursByTech"
                ];
            const labels = [];
            const dataSets = [
                {
                    label: "Non-Productive Hours Overtime",
                    backgroundColor: "rgba(153, 102, 255, 0.6)",
                    data: [],
                },
                {
                    label: "Non-Productive Hours Straight",
                    backgroundColor: "rgba(255, 206, 86, 0.6)",
                    data: [],
                },
                {
                    label: "Total Non-Productive Hours",
                    backgroundColor: "rgba(75, 192, 192, 0.6)",
                    data: [],
                },
            ];

            if (
                dataList &&
                dataList["customer-no-of-non-productive-hours-by-tech"]
            ) {
                if (
                    dataList["customer-no-of-non-productive-hours-by-tech"]
                        .length > 0
                ) {
                    dataList["customer-no-of-non-productive-hours-by-tech"].map(
                        (el) => {
                            labels.push(el.Tech_Name);
                            dataSets[0].data.push(
                                parseFloat(
                                    el.non_productive_hours_overtime
                                ).toFixed(2)
                            );
                            dataSets[1].data.push(
                                parseFloat(
                                    el.non_productive_hours_straight
                                ).toFixed(2)
                            );
                            dataSets[2].data.push(
                                parseFloat(
                                    el.total_non_productive_hours
                                ).toFixed(2)
                            );
                        }
                    );
                }
            }
            return {
                labels,
                datasets: dataSets,
            };
        },
        barChartOptions2() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        stacked: false,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                    y: {
                        stacked: false,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                },
                plugins: {
                    tooltip: {
                        callbacks: {
                            label: (tooltipItem) => {
                                let data =
                                    this.$store.getters[
                                        "partner/getCustomerNoOfNonProdHoursByTech"
                                    ];
                                if (
                                    data &&
                                    data[
                                        "customer-no-of-non-productive-hours-by-tech"
                                    ]
                                ) {
                                    const item = data[
                                        "customer-no-of-non-productive-hours-by-tech"
                                    ].find(
                                        (el) =>
                                            el.Customer_Name ===
                                            tooltipItem.label
                                    );
                                    if (item) {
                                        return `${item.Type}: ${tooltipItem.raw}`;
                                    }
                                }
                                return tooltipItem.raw;
                            },
                        },
                    },
                },
            };
        },
        chartData3() {
            const dataList =
                this.$store.getters["partner/getNoOfNonProdHoursByTech"];
            const labels = [];
            const dataSets = [
                {
                    label: "Non-Productive Hours Overtime",
                    backgroundColor: "rgba(54, 162, 235, 0.6)",
                    data: [],
                },
                {
                    label: "Non-Productive Hours Straight",
                    backgroundColor: "rgba(255, 159, 64, 0.6)",
                    data: [],
                },
                {
                    label: "Total Non-Productive Hours",
                    backgroundColor: "rgba(75, 192, 192, 0.6)",
                    data: [],
                },
            ];

            if (dataList && dataList["no-of-non-productive-hours-by-tech"]) {
                if (dataList["no-of-non-productive-hours-by-tech"].length > 0) {
                    dataList["no-of-non-productive-hours-by-tech"].map((el) => {
                        labels.push(el.Tech_Name);
                        dataSets[0].data.push(
                            parseFloat(
                                el.non_productive_hours_overtime
                            ).toFixed(2)
                        );
                        dataSets[1].data.push(
                            parseFloat(
                                el.non_productive_hours_straight
                            ).toFixed(2)
                        );
                        dataSets[2].data.push(
                            parseFloat(el.total_non_productive_hours).toFixed(2)
                        );
                    });
                }
            }
            return {
                labels,
                datasets: dataSets,
            };
        },
        barChartOptions3() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        stacked: false,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                    y: {
                        stacked: false,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                },
                plugins: {
                    tooltip: {
                        callbacks: {
                            label: (tooltipItem) => {
                                let data =
                                    this.$store.getters[
                                        "partner/getNoOfNonProdHoursByTech"
                                    ];
                                if (
                                    data &&
                                    data["no-of-non-productive-hours-by-tech"]
                                ) {
                                    const item = data[
                                        "no-of-non-productive-hours-by-tech"
                                    ].find(
                                        (el) =>
                                            el.Customer_Name ===
                                            tooltipItem.label
                                    );
                                    if (item) {
                                        return `${item.Type}: ${tooltipItem.raw}`;
                                    }
                                }
                                return tooltipItem.raw;
                            },
                        },
                    },
                },
            };
        },
    },
    methods: {
        async changeCustomer(selected) {
            if (selected.value === "all") {
                await this.fetchCustomerNumberOfDSOList();
                return;
            } else await this.fetchNumberOfDSO(selected);
        },
        async changeCustomer2(selected) {
            if (selected.value === "all") {
                await this.fetchUsdValueOfTickets();
                return;
            } else await this.fetchCustomerUsdValueOfTickets(selected);
        },
        async changeCustomer3(selected) {
            if (selected.value === "all") {
                await this.fetchNoOfNonProdHoursByTech();
                return;
            } else await this.fetchCustomerNoOfNonProdHoursByTech(selected);
        },
        async fetchCustomerNumberOfDSOList() {
            this.isLoading = true;
            const dataList = [
                {
                    key: "customer-no-of-dso-list",
                    variables: {
                        fromDate: this.startDate || "2024-01-30",
                        toDate: this.endDate || "2025-02-20",
                    },
                },
            ];
            await this.$store.dispatch("partner/fetchCustomerNumberOfDSOList", {
                items: dataList,
            });
            this.isLoading = false;
        },
        async fetchNumberOfDSO(customerName) {
            this.isLoading = true;
            if (!customerName || !customerName.text) {
                console.error("Invalid customer name:", customerName);
                return;
            }
            const dataList = [
                {
                    key: "no-of-dso",
                    variables: {
                        fromDate: this.startDate2 || "2024-01-30",
                        toDate: this.endDate2 || "2025-02-17",
                        Customer: customerName.text,
                    },
                },
            ];
            const data = await this.$store.dispatch(
                "partner/fetchNumberOfDSO",
                {
                    items: dataList,
                }
            );
            this.isLoading = false;
        },
        async fetchUsdValueOfTickets() {
            this.isLoading = true;
            const dataList = [
                {
                    key: "usd-value-of-tickets",
                    variables: {
                        fromDate: this.startDate3 || "2024-01-30",
                        toDate: this.endDate3 || "2025-02-17",
                    },
                },
            ];
            const data = await this.$store.dispatch(
                "partner/fetchUsdValueOfTickets",
                {
                    items: dataList,
                }
            );
            this.isLoading = false;
        },
        async fetchCustomerUsdValueOfTickets(customerName) {
            this.isLoading = true;
            if (!customerName || !customerName.text) {
                console.error("Invalid customer name:", customerName);
                return;
            }
            const dataList = [
                {
                    key: "customer-usd-value-of-tickets",
                    variables: {
                        fromDate: this.startDate4 || "2024-01-01",
                        toDate: this.endDate4 || "2025-02-20",
                        Customer: customerName.text,
                    },
                },
            ];
            const data = await this.$store.dispatch(
                "partner/fetchCustomerUsdValueOfTickets",
                {
                    items: dataList,
                }
            );
            this.isLoading = false;
        },
        async fetchCustomerNoOfNonProdHoursByTech(customerName) {
            this.isLoading = true;
            if (!customerName || !customerName.text) {
                console.error("Invalid customer name:", customerName);
                return;
            }
            const dataList = [
                {
                    key: "customer-no-of-non-productive-hours-by-tech",
                    variables: {
                        fromDate: this.startDate5 || "2024-01-01",
                        toDate: this.endDate5 || "2025-02-20",
                        Customer: customerName.text,
                    },
                },
            ];
            await this.$store.dispatch(
                "partner/fetchCustomerNoOfNonProdHoursByTech",
                {
                    items: dataList,
                }
            );
            this.isLoading = false;
        },
        async fetchNoOfNonProdHoursByTech() {
            this.isLoading = true;
            const dataList = [
                {
                    key: "no-of-non-productive-hours-by-tech",
                    variables: {
                        fromDate: this.startDate6 || "2024-01-01",
                        toDate: this.endDate6 || "2025-02-20",
                    },
                },
            ];
            await this.$store.dispatch("partner/fetchNoOfNonProdHoursByTech", {
                items: dataList,
            });
            this.isLoading = false;
        },
        getDateInfo(dateData) {
            if (dateData == "custom") {
                const data = {
                    fromDate: this.startDate,
                    toDate: this.endDate,
                };
                return data;
            }
            if (typeof dateData === "number") {
                const data = {
                    fromDate: moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                return data;
            }
        },
        changeDate(e) {
            if (e.value == "custom") {
                this.$refs["compRefs"].openModal();
                return;
            }
            const dateInfo = this.getDateInfo(e.value);
            this.startDate = dateInfo.fromDate;
            this.endDate = dateInfo.toDate;
            this.fetchCustomerNumberOfDSOList();
        },
        findDateResult(e) {
            this.startDate = e.fromDate;
            this.endDate = e.toDate;
            this.fetchCustomerNumberOfDSOList();
        },
        changeDate2(e) {
            if (e.value == "custom") {
                this.$refs["compRefs2"].openModal();
                return;
            }
            const dateInfo = this.getDateInfo(e.value);
            this.startDate2 = dateInfo.fromDate;
            this.endDate2 = dateInfo.toDate;
            this.fetchNumberOfDSO();
        },
        findDateResult2(e) {
            this.startDate2 = e.fromDate;
            this.endDate2 = e.toDate;
            this.fetchNumberOfDSO();
        },
        changeDate3(e) {
            if (e.value == "custom") {
                this.$refs["compRefs3"].openModal();
                return;
            }
            const dateInfo = this.getDateInfo(e.value);
            this.startDate3 = dateInfo.fromDate;
            this.endDate3 = dateInfo.toDate;
            this.fetchUsdValueOfTickets();
        },
        findDateResult3(e) {
            this.startDate3 = e.fromDate;
            this.endDate3 = e.toDate;
            this.fetchUsdValueOfTickets();
        },
        changeDate4(e) {
            if (e.value == "custom") {
                this.$refs["compRefs4"].openModal();
                return;
            }
            const dateInfo = this.getDateInfo(e.value);
            this.startDate4 = dateInfo.fromDate;
            this.endDate4 = dateInfo.toDate;
            this.fetchCustomerUsdValueOfTickets();
        },
        findDateResult4(e) {
            this.startDate4 = e.fromDate;
            this.endDate4 = e.toDate;
            this.fetchCustomerUsdValueOfTickets();
        },
        changeDate5(e) {
            if (e.value == "custom") {
                this.$refs["compRefs5"].openModal();
                return;
            }
            const dateInfo = this.getDateInfo(e.value);
            this.startDate5 = dateInfo.fromDate;
            this.endDate5 = dateInfo.toDate;
            this.fetchCustomerNoOfNonProdHoursByTech();
        },
        findDateResult5(e) {
            this.startDate5 = e.fromDate;
            this.endDate5 = e.toDate;
            this.fetchCustomerNoOfNonProdHoursByTech();
        },
        changeDate6(e) {
            if (e.value == "custom") {
                this.$refs["compRefs6"].openModal();
                return;
            }
            const dateInfo = this.getDateInfo(e.value);
            this.startDate6 = dateInfo.fromDate;
            this.endDate6 = dateInfo.toDate;
            this.fetchNoOfNonProdHoursByTech();
        },
        findDateResult6(e) {
            this.startDate6 = e.fromDate;
            this.endDate6 = e.toDate;
            this.fetchNoOfNonProdHoursByTech();
        },
        fetchReportData() {
            this.fetchCustomerNumberOfDSOList();
            this.fetchNumberOfDSO();
            this.fetchUsdValueOfTickets();
            this.fetchCustomerUsdValueOfTickets();
            this.fetchCustomerNoOfNonProdHoursByTech();
            this.fetchNoOfNonProdHoursByTech();
        },
    },
    mounted() {
        this.fetchCustomerNumberOfDSOList();
        this.fetchNumberOfDSO();
        this.fetchUsdValueOfTickets();
        this.fetchCustomerUsdValueOfTickets();
        this.fetchCustomerNoOfNonProdHoursByTech();
        this.fetchNoOfNonProdHoursByTech();
    },
};
</script>

<style scoped>
.no-data-margin {
    margin: 0;
}
</style>
